var { createElement, useEffect, useState } = require("react");

module.exports = function Icon({ name, size }) {
    const [DynamicIcon, setDynamicIcon] = useState(null)

    useEffect(() => {
        (async () => {
            let result = await import(`./react-icons-pre-compiled/${name}.js`)
            setDynamicIcon(result);
        })();
    }, [name])

    return DynamicIcon ? createElement(DynamicIcon.default, {size: size}) : null;
}